import { render, staticRenderFns } from "./ChannelInfoModal.vue?vue&type=template&id=08f05e44&scoped=true&"
import script from "./ChannelInfoModal.vue?vue&type=script&lang=js&"
export * from "./ChannelInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ChannelInfoModal.vue?vue&type=style&index=0&id=08f05e44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f05e44",
  null
  
)

export default component.exports